import {Button} from 'platform/components';

import {isNil, isNotNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {CustomerMessageResponseBody} from '@dms/api/core';
import {i18n} from '@dms/i18n';

import {truncateSubject} from '../utils/truncateSubject';

interface ThreadInReplyToChipProps {
  parentMessage: CustomerMessageResponseBody | null;
  onClick: VoidFunction;
}

export function ThreadInReplyToChip(props: ThreadInReplyToChipProps) {
  const title =
    isNotNil(props.parentMessage) &&
    isNotNil(props.parentMessage.subject) &&
    isNotNilOrEmpty(props.parentMessage.subject)
      ? i18n.t('entity.customerMessage.labels.inReplyTo', {
          subject: truncateSubject(props.parentMessage.subject),
        })
      : i18n.t('entity.customerMessage.labels.inReplyToEarlierMessage');

  return (
    <Button
      variant="ghostLink"
      size="small"
      leftIcon="navigation/subdirectory_arrow_left"
      title={title}
      isDisabled={isNil(props.parentMessage)}
      onClick={props.onClick}
      data-testid="communicationThread-inReplyTo"
    />
  );
}
